import { IAddOnsAppText, defaultText } from '../../custom/classes/add-ons-text';
import { ActionType, IAddOnsStateAction } from '../../classes/add-on-actions';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function addOnsTextReducer(state: IAddOnsAppText = defaultText, action: IAddOnsStateAction) {
    switch (action.type) {
        case ActionType.UpdateSettings: {
            return { ...state, ...action.value, requesting: false, apiError: null } as IAddOnsAppText;
        }
        default:
            return state;
    }
}
